module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-en.bc8f75771b6bf83f27a2.svg";